import { render, staticRenderFns } from "./ViewMyTraining.vue?vue&type=template&id=3c6f3e98&scoped=true"
import script from "./ViewMyTraining.vue?vue&type=script&lang=js"
export * from "./ViewMyTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6f3e98",
  null
  
)

export default component.exports